// extracted by mini-css-extract-plugin
module.exports = {"root":"Navigation-root-Gli-1","ul":"Navigation-ul-1wfjN"};